import { Table, Tabs, Tab } from 'appkit-react';

const FileData = ({
    fileName, disableFileTab, isfilteredData, fileData, fileCols,
    onTabChange,
}) => (
    <>
        <Tabs
            id="controlled-tab-example1"
            defaultValue="3"
            onChange={onTabChange}
            className="mb-3"
        >
            <Tab
                value="3"
                label="FILE DATA"
                disabled={disableFileTab}
            >
                <>
                    {isfilteredData && (
                        <div className="a-h6" style={{ marginTop: '1rem' }}>
                            Showing Filtered Data
                        </div>
                    )}
                    <div className="a-h6" style={{ marginTop: '0.5rem' }}>
                        {`File Name : ${fileName.split('_').slice(1, fileName.length).join('_')}`}
                    </div>
                    <div
                        style={{ paddingBottom: '1rem' }}
                        className="true-comply-data-recon-result-table_container"
                    >
                        <Table
                            data={fileData}
                            columns={fileCols}
                            defaultPageSize={10}
                            sortable
                            size="lg"
                            resizable
                            className="-striped -highlight ReactTable rt-expander"
                        />
                    </div>
                </>
            </Tab>

        </Tabs>
    </>
);

export default FileData;
